import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=18b3bfca&scoped=true&"
import script from "./additional.vue?vue&type=script&lang=ts&"
export * from "./additional.vue?vue&type=script&lang=ts&"
import style0 from "./additional.vue?vue&type=style&index=0&id=18b3bfca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3bfca",
  null
  
)

export default component.exports